import { Collapse, Flex, Table } from 'antd';

const columns = [
    {
        title: 'Loại',
        dataIndex: 'title',
        key: 'title',
    },
    {
        title: 'Tham số',
        dataIndex: 'parameter',
        key: 'parameter',
    },
    {
        title: 'Kiểu dữ liệu',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: 'Mô tả',
        dataIndex: 'description',
        key: 'description',
    },
];

const dataSource = [
    {
        title: 'Body JSON',
        parameter: 'domain',
        type: 'String',
        description: 'Tên miền muốn sử dụng',
    },
    {
        title: 'Body JSON',
        parameter: 'instance_id',
        type: 'Number | String',
        description: 'ID máy chủ muốn triển khai website',
    },
    {
        title: 'Body JSON',
        parameter: 'pricing_id',
        type: 'Number | String',
        description: 'ID chu kỳ mẫu website muốn đăng ký',
    },
];

const example = {
    domain: 'test.com',
    instance_id: 32483388,
    pricing_id: 14935556,
};

const responseSuccess = {
    data: {
        template: {
            id: 23176528,
            title: 'Web clone trang nạp thẻ của Garena',
        },
        cloudflare: {
            name: 'test.com',
            status: 'pending',
            name_servers: ['lennon.ns.cloudflare.com', 'love.ns.cloudflare.com'],
            original_name_servers: ['ns1.safesecureweb.com', 'ns2.safesecureweb.com', 'ns3.safesecureweb.com'],
        },
        auto_renew: false,
        id: 19777564,
        status: 'confirming',
        app_domain: 'test.com',
        email_admin: 'test.com@thegioicode.com',
        description: 'Vui lòng trỏ Nameservers gốc về Nameservers mới của chúng tôi!',
        admin_domain: 'admin.test.com',
        password_admin: 'ktC7AI9t#Y#K',
        created_at: '2025-05-19 21:06:16',
        expired_at: '2025-08-19 23:59:59',
    },
    status: 200,
    message: 'Khởi tạo đơn tạo website thành công',
};

function Deploy() {
    return (
        <Collapse
            items={[
                {
                    key: '1',
                    label: <div className="font-bold text-hover">Khởi tạo website</div>,
                    children: (
                        <div>
                            <Flex align="center">
                                <span className="document-method text-warning font-bold">POST</span>
                                <span className="document-method flex-1 text-start">https://thegioicode.com/api/v2/templates/deploy</span>
                            </Flex>

                            <Table className="mt-4" bordered columns={columns} dataSource={dataSource} pagination={false} />

                            <div className="mt-3 mb-1">Body:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy warning">{JSON.stringify(example, null, 2)}</code>
                                    </pre>
                                </div>
                            </div>

                            <div className="mt-3 mb-1">Thành công:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy success">{JSON.stringify(responseSuccess, null, 2)}</code>
                                    </pre>
                                </div>
                            </div>

                            <div className="mt-3 mb-1">Thất bại:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy">
                                            {JSON.stringify({ status: 'Mã code lỗi', error: 'Thông tin lỗi trả về' }, null, 4)}
                                        </code>
                                    </pre>
                                </div>
                            </div>
                        </div>
                    ),
                },
            ]}
        />
    );
}

export default Deploy;
